module.exports = __webpack_public_path__ + "img/defaultImg.0030ea2d.png";